<template lang="pug">
    div
        div(v-if="index !== 0" :class="{ 'is-and': this.boxLabel.toLowerCase() === 'and', 'is-not': this.boxLabel.toLowerCase() === 'not' }")
            span {{ this.boxLabel }}
        .formula-block(
            :class="[boxFormulaClass, boxFocusedClass]"
            @click.prevent="box.formula.selectBox(index)"
        )
            //- HEADER
            .formula-block-header.l-flex-row--rev
                CellVolume(
                    parent="builder"
                    :fullData="volume"
                    type="volume"
                    :isBoxFormula="true"
                )
                .formula-block-action.action-hidden-menu
                    svg-icon.cursor(name='dots' size='medium')
                    .menu-action-hidden--right
                        ul
                            li.dot-menu-item(
                                :class="{ 'is-disabled': box.isEmpty }",
                                @click.stop="box.toggleDisable()"
                            )
                                label {{ box.disabled ? 'Enable criteria' : 'Disable criteria' }}
                            li.dot-menu-item(
                                :class="{ 'is-disabled': box.isEmpty }",
                                @click.stop="box.removeAllCriterion()"
                            )
                                label Flush criteria
                            li.dot-menu-item(
                                @click.stop="box.formula.removeBox(index)"
                            )
                                label Delete box

            //- CONTENT
            .formula-block-content.l-flex-column(:class="{ 'isEmpty': box.isEmpty }")
                template(v-if="box.isEmpty")
                    strong Box is empty
                    div Select some criterion
                template(v-else)
                    FormulaCriterion(
                        v-for="(criterion, index) in box.criteria"
                        :box="box"
                        :criterion="criterion"
                        :index="index"
                        :volume="criterionVolumes[index]"
                    )

</template>

<script>
import { mapState } from 'vuex'

import CellVolume from '@/components/monitoring/CellVolume'
import FormulaCriterion from './FormulaCriterion.vue'

export default {
    name: 'FormulaBox',

    components: {
        CellVolume,
        FormulaCriterion
    },

    props: {
        box: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        volumeIndex: {
            type: Number,
            default: undefined
        }
    },

    computed: {
        ...mapState('builder', {
            formulaVolumes: state => state.formulaVolumes,
            formulaVolumesLoading: state => state.formulaVolumesLoading
        }),

        boxFocusedClass() {
            return this.box.selected ? 'isFocused' : ''
        },

        boxFormulaClass() {
            return 'formula-box__' + this.box.type
        },

        blockLabelClass() {
            return this.box.type === 'inclusive' ? 'txt-and' : 'txt-not'
        },

        boxLabel() {
            return this.box.type === 'inclusive' ? 'AND' : 'NOT'
        },

        volume() {
            return this.box.isEmpty || this.box.disabled || this.formulaVolumesLoading ? undefined : this.getVolumes()
        },

        criterionVolumes() {
            let counter = 0
            let disabled = 0
            return this.box.criteria.map(criterion => {
                const actual = counter
                counter++

                //This.volume doesn't retrieve volumes for disabled elements so we need to substract them to get the correct indexes
                if (criterion.disabled) {
                    disabled++
                    return null
                }
                if (this.box.type === 'inclusive') return criterion.disabled ? null : this.volume?.children?.[actual - disabled]
                else return criterion.disabled ? null : this.volume?.children[0]?.children?.[actual - disabled]
            })
        }
    },

    methods: {
        getVolumes() {
            return this.formulaVolumes?.[this.volumeIndex]
        }
    }
}
</script>

<style lang="scss">
.is-and, .is-not {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    position: relative;
    &::before {
        content: ' ';
        width: 100%;
        background: gray;
        height: 1px;
        position: absolute
    }
    span {
        padding: 2px 10px;
        color: white;
        border-radius: 4px;
        z-index: 99;
    }
}
.is-and {
    &::before {
        background: var(--color-success);
    }
    span {
        background: var(--color-success);
        border: 1px solid var(--color-success);
    }
}

.is-not {
    &::before {
        background: var(--color-danger);
    }
    span {
        background: var(--color-danger);
        border: 1px solid var(--color-danger);
    }
}
</style>
